import { useEffect, useState } from 'react';

const DEFAULT_DELAY = 200; // ms;

export const useDebounce = <T>(value: T, delay: number = DEFAULT_DELAY): T => {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    // Flush immediately when value is empty string so clears don't leave stale debounced values
    if (value === '') {
      setDebounced(value);
      return;
    }

    const timeout = setTimeout(() => {
      setDebounced(value);
    }, delay);

    return () => {
      clearTimeout(timeout);
    };
  }, [value, delay]);
  return debounced;
};
